import BaseLayer from "./BaseLayer";
import {drawCircle, drawLine, getHighestFocusPoint, mapMotorToCanvas} from "../utils/map_utils";
import {Grid, Stack} from "@mui/material";
import {getPrefixedUrl} from "../../../utils/utils";
import React from "react";
import {getFinalPlotData, getPlotPopup, plotDicyStreak} from "./TileLayersUtils";
import {zProfileFolderPath} from "../../../utils/const";

class RescanFocusPoints extends BaseLayer {

    id = "rescanFocusPoints";
    label = "Rescan Focus Points";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {y_fields, tile_viewer_path, tile_height, uperpixel, loc_on_machine, bucket_name} = this.props.slide;
        let {
            islands,
            deviceSettings,
            focusProfile,
            tiltFocusPoints,
            countyTiltInfo,
            focusDirPath,
            focusOffset,
            textColor,
            textSize,
            focusImgPath,
            focusDicy,
            focusPlots,
            tileFlag,
            slide
        } = this.props;
        if (islands.length > 0 && islands[0]["counties"]) {
            let takeNumber = 1;
            let xOffset = focusOffset['xy']["x_offset"];
            let yOffset = focusOffset['xy']["y_offset"];
            let highestPoint = getHighestFocusPoint(tiltFocusPoints, focusProfile, countyTiltInfo);
            for (let i = 0; i < focusProfile.length; i++) {
                if (focusProfile[i]["islandKey"]["takeNumber"] !== takeNumber)
                    continue;
                let countyData = focusProfile[i]["counties"];
                for (let idx = 0; idx < countyData.length; idx++) {
                    let focusList = countyData[idx]['focusList'];
                    let county = countyData[idx]['countyId'];
                    let dualFocusList = countyData[idx]['dualFocusList'];
                    if (dualFocusList)
                        focusList = focusList.concat(dualFocusList);
                    if (focusList) {
                        for (let j = 0; j < focusList.length; j++) {
                            if (focusList[j]['focusedAt'] !== null) {
                                let motorX = focusList[j]['focusedAt']['xPosition'] - xOffset;
                                let motorY = focusList[j]['focusedAt']['yPosition'] - yOffset;
                                let {x, y} = mapMotorToCanvas(motorX, motorY, slide,
                                    {device_settings: deviceSettings});
                                if (tileFlag['reverseYTileOrder']['flagY'])
                                    y = slide.y_fields * (tile_height * uperpixel) - y;
                                let zProfilePath = '';
                                for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                                    const path = focusDirPath.focus_profile_dir_paths[l].split("_");
                                    const lastElement = path.pop();
                                    if (focusList[j]['unifiedFocusId'] === parseInt(lastElement)) {
                                        zProfilePath = focusDirPath.focus_profile_dir_paths[l];
                                    }
                                }
                                Object.values(focusPlots).forEach(val => {
                                    if (focusList[j]['unifiedFocusId'] === parseInt(val['index'])) {
                                        let finalPlotData = getFinalPlotData(val);
                                        let popup = getPlotPopup(zProfilePath, finalPlotData, val['index']);
                                        drawLine(x + 0.1 * tile_height * uperpixel, y, 1, this.layer.getSource(),
                                            "[PLOT]", 10, "#f4c2c2", popup, textColor, 10);
                                    }
                                });
                                let link2 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                                    zProfileFolderPath + zProfilePath + "/";
                                let link1 = '', isFine = '';
                                Object.values(focusImgPath).forEach(val => {
                                    if (focusList[j]['unifiedFocusId'] === parseInt(val['index'])) {
                                        link1 = getPrefixedUrl(`debug/zprofile/${val["img"]}`, this.props.slide, true);
                                        isFine = val["isFineLocated"];
                                    }
                                });
                                let popupText = (
                                    <Stack>
                                        {"Focus ID DOWN " + focusList[j]['unifiedFocusId'] + "(" +
                                            focusList[j]['focusedDown'] + ")"}
                                        {" CountyId: " + county}
                                        <Grid>
                                            <a href={link2}>{"ID " + focusList[j]['unifiedFocusId'] + " Location "}</a>
                                            <a href={link1}
                                               target={"_blank"}>{isFine ? " [Fine Locator Img]"
                                                : "[Best Focussed Img]"}</a>
                                        </Grid>
                                    </Stack>
                                );
                                drawCircle(x, y, 0.3 * tile_height * uperpixel, this.layer.getSource(), "",
                                    16, "#21F558", popupText, textColor);
                                if (highestPoint) {
                                    let zdiff = focusList[j]['focusedDown'] - highestPoint;
                                    zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                                    drawLine(x, y - 0.3 * tile_height * uperpixel, 1, this.layer.getSource(),
                                        "Δz " + zdiff, 10, "#E9D6C5", "", textColor, textSize);
                                }

                                Object.values(focusDicy).forEach(val => {
                                    if (focusList[j]['unifiedFocusId'] === parseInt(val['id'])) {
                                        let folderLink = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                                            zProfileFolderPath + val["folder"] + "/" + val["subFolder"];
                                        let vectorSource = this.layer.getSource();
                                        plotDicyStreak(tileFlag, val, this.props.slide, vectorSource, deviceSettings, y_fields,
                                            tile_height, uperpixel, textColor, textSize, folderLink);
                                    }
                                });
                            }
                        }
                    }
                }
            }
        }
        resolve();
    });
}

export default RescanFocusPoints;